import React from "react";
import { Col } from "common/components/layout-styles";
import SelectedSearchFilter from "search-filter/components/search-filter-bar/SelectedSearchFilter";
import useSearchFiltersFormState from "search-filter/hooks/useSearchFiltersFormState";
const SelectedFiltersOverview = ({ isParentMutable = true }) => {
  const selectedFilters = useSearchFiltersFormState();
  return /* @__PURE__ */ React.createElement(Col, { $gap: "md", $align: "flex-start" }, selectedFilters.toArray().map((filter) => /* @__PURE__ */ React.createElement(SelectedSearchFilter, { filter, key: filter.frontendId, isParentMutable })));
};
export default SelectedFiltersOverview;
